import { defaultGoalsOverviewFilterDocument } from '@griply/utils';

export const defaultFilterDocument = defaultGoalsOverviewFilterDocument;
